<template>
  <div id="audio-viewer">
    <p style="font-size: 0.5rem;color: #2d2d2f;margin-top: 1.5rem">{{fileName}}</p>
    <div style="margin-top: 1rem">
      <vue-audio
        v-bind:audio-source="filePath"
      ></vue-audio>
    </div>
  </div>


</template>

<script>
export default {
  name: 'AudioViewer',
  data(){
    return{
      rotationAngle: 0,
      rotateStatus: false,
      timer: null,
      fileName: '',
      filePath: 'https://example.com/example.mp3', // 需要有一个默认值，不然会报错
      downloadStatus: false,
    }
  },
  beforeCreate() {
    console.log("beforeCreate")

  },
  created() {
    console.log("created")
    // 获取id
    let id = this.$route.query.id

    let ids = id.split("-");
    this.downloadStatus = ids[0]%2===0
    this.getFile(ids[1])

  },
  beforeMount() {
    console.log("beforeMount")
  },
  mounted() {
    console.log("mounted")
  },
  methods: {

    async getFile(id){
      const { $http } = this;
      let path = "resource/query?id="+id;
      await $http.get(path).then((res) => {
        console.log("res",res)
        let data = res.data;
        console.log("data",data);
        if (data.hasOwnProperty("filePath")){
          this.fileName = data["fileTitle"].substring(0, data["fileTitle"].lastIndexOf(".")); // 获取文件名称
          this.filePath = data["filePath"];
          console.log("fileName",this.fileName)
          console.log("filePath",this.filePath)
        }
      });

    }
  }
}

</script>

<style scoped>

#audio-viewer{
  font-size: .5rem;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

/deep/ .vueAudioBetter{
  width: 90% !important;
}

</style>